import React, { useCallback, useEffect, useState } from 'react'
import EditDropDown from "../../../UI/EditDropDown/EditDropDown"
import { useTranslation } from "react-i18next";
import styles from './ActivityManagement.module.css'
import { getDropDownList, updateDropDownList, updateDropDownItem, deleteDropDownItem, deleteDropDown, insertDropDownList } from '../../../../axios/requests/dropDownReq'
import useDropDown from '../../../../hooks/use-dropDown';
import MultipleSelection from '../../../UI/MultipleSelection/MultipleSelection';


export default (props) => {
    const [t] = useTranslation('common')

    // const [selectedOptions, setSelectedOptions] = useState([]);

    const {
        dropDownItem: activitySelectedItem,
        dropDownObj: activityDropDownObj,
        initDropDown: initActivityDropDown,
        setDropDownObj: setDropDownActivityObj,
        setDropDownSelectedItem: setDropDownActivitySelectedItem,
        setDropDownItemName: setDropDownActivityItemName,
        deleteDropDownItem: deleteDropDownActivityItem,
        saveDropDownItem: saveDropDownActivityItem
    } = useDropDown('CONTACT_ACTIVITY')

    const {
        dropDownItem: subjectSelectedItem,
        dropDownObj: subjectDropDownObj,
        initDropDown: initSubjectDropDown,
        setDropDownObj: setDropDownSubjectObj,
        setDropDownSelectedItem: setDropDownSubjectSelectedItem,
        setDropDownItemName: setDropDownSubjectItemName,
        deleteDropDownItem: deleteDropDownSubjectItem,
        saveDropDownItem: saveDropDownSubjectItem
    } = useDropDown('CONTACT_SUBJECT')

    const {
        dropDownItem: activitySubjectsSelectedItem,
        dropDownObj: activitySubjectsDropDownObj,
        initDropDown: initActivitySubjectsDropDown,
        setDropDownObj: setDropDownActivitySubjectsObj,
        setDropDownSelectedItem: setDropDownActivitySubjectsSelectedItem,
        setDropDownItemName: setDropDownActivitySubjectsItemName,
        deleteDropDownItem: deleteDropDownActivitySubjectsItem,
        saveDropDownItem: saveDropDownActivitySubjectsItem,
        setDropDownName: setActivitySubjectsDropDownName,
        resetDropDown : resetActivitySubjectsDropDown
    } = useDropDown('CONTACT_ACTIVITY_SUBJECT')
    let subjectOptionList = []
    if (activitySelectedItem._id) {
        subjectOptionList = subjectDropDownObj?.dropDownItems.filter(dDItem => dDItem._id).map(dDItem => ({ id: dDItem._id, label: dDItem.key, value:dDItem?.value, selectedObj: dDItem }))
    }
    const activitySubjectsSelectedOpt = activitySubjectsDropDownObj?.dropDownItems.filter(dDItem => dDItem._id).map(dDItem => dDItem.value)
    console.log('activitySubjectsSelectedOpt')
    console.log(activitySubjectsSelectedOpt)
    const fetchActivityDropDownData = useCallback(async () => {
        const activityDropDownListTemp = await getDropDownList('CONTACT_ACTIVITY');
        if (activityDropDownListTemp.length > 0) {
            initActivityDropDown(activityDropDownListTemp[0])
        }
    }, [initActivityDropDown])

    const fetchSubjectDropDownData = useCallback(async () => {
        const subjectDropDownListTemp = await getDropDownList('CONTACT_SUBJECT');
        if (subjectDropDownListTemp.length > 0) {
            initSubjectDropDown(subjectDropDownListTemp[0])
        }
    }, [initSubjectDropDown])

    const fetchActivitySubjectsDropDownData = useCallback(async (name) => {
        resetActivitySubjectsDropDown()
        setActivitySubjectsDropDownName(name)
        const subjectDropDownListTemp = await getDropDownList('CONTACT_ACTIVITY_SUBJECT', name);
        if (subjectDropDownListTemp.length > 0) {
            initActivitySubjectsDropDown(subjectDropDownListTemp[0])
        }
    }, [resetActivitySubjectsDropDown,setActivitySubjectsDropDownName,initActivitySubjectsDropDown])

    useEffect(() => {
        fetchActivityDropDownData()
        fetchSubjectDropDownData()
    }, [])


    const onSaveActivityItemClickHandler = useCallback(async () => {
        await updateDropDownItem(activityDropDownObj, activitySelectedItem)
        fetchActivityDropDownData()
        // saveDropDownActivityItem(activitySelectedItem)
    }, [activityDropDownObj, activitySelectedItem])


    const onDeleteActivityItemClickHandler = useCallback(async () => {
        await deleteDropDownItem(activityDropDownObj, activitySelectedItem)
        fetchActivityDropDownData()
        // deleteDropDownActivityItem(activitySelectedItem)
    }, [activityDropDownObj, activitySelectedItem])

    const onSaveSubjectItemClickHandler = useCallback(async () => {
        await updateDropDownItem(subjectDropDownObj, subjectSelectedItem)
        fetchSubjectDropDownData()
        // saveDropDownSubjectItem(subjectSelectedItem)
    }, [subjectDropDownObj, subjectSelectedItem])


    const onDeleteSubjectItemClickHandler = useCallback(async () => {
        await deleteDropDownItem(subjectDropDownObj, subjectSelectedItem)
        fetchSubjectDropDownData()
        // deleteDropDownSubjectItem(subjectSelectedItem)
    }, [subjectDropDownObj, subjectSelectedItem])

    const onSaveActivitySubjectsItemClickHandler = useCallback(async (selectedItem) => {
        saveDropDownActivitySubjectsItem(selectedItem)
        await updateDropDownItem(activitySubjectsDropDownObj, selectedItem)
    }, [activitySubjectsDropDownObj, saveDropDownActivitySubjectsItem])


    const onDeleteActivitySubjectsItemClickHandler = useCallback(async (selectedItem) => {
        deleteDropDownActivitySubjectsItem(selectedItem)
        await deleteDropDownItem(activitySubjectsDropDownObj, selectedItem)
    }, [activitySubjectsDropDownObj, deleteDropDownActivitySubjectsItem])

    const toggleOption = useCallback((selectedItem) => {
        if (activitySubjectsDropDownObj?.dropDownItems.find(dDitem => dDitem.value === selectedItem.value)) {//turn off the toggel
            onDeleteActivitySubjectsItemClickHandler(selectedItem)
        } else {//turn on the toggle
            onSaveActivitySubjectsItemClickHandler(selectedItem)
        }
    }, [deleteDropDownActivitySubjectsItem, saveDropDownActivitySubjectsItem, activitySubjectsDropDownObj]);

    const onSelectActivity = useCallback(async (selectedActivity) => {
        setDropDownActivitySelectedItem(selectedActivity)
        fetchActivitySubjectsDropDownData(selectedActivity.value)
    }, [setDropDownActivitySelectedItem, fetchActivitySubjectsDropDownData, activitySubjectsDropDownObj])

    return (
        <artical className={styles['edit-dropdown-container']}>
            <EditDropDown
                management={t('Subject')}
                dropDownLabel={t('Select Subject')}
                textLabel={t('Subject name')}
                selectedDropDownItemObj={subjectSelectedItem}
                defaultSelectedItemName={t('Create new dropdown item')}
                dropDownItems={subjectDropDownObj?.dropDownItems}
                onDropDownNameChanged={(e) => setDropDownSubjectItemName(e.target.value)}
                onSaveDropDownItemClick={onSaveSubjectItemClickHandler}
                onDeleteDropDownItemClick={onDeleteSubjectItemClickHandler}
                onSelectDropDownItem={setDropDownSubjectSelectedItem}
            />
            <div className={styles['block-tiny-line']} />
            <EditDropDown
                management={t('Activity')}
                dropDownLabel={t('Select activity')}
                textLabel={t('Activity name')}
                selectedDropDownItemObj={activitySelectedItem}
                defaultSelectedItemName={t('Create new dropdown item')}
                onDropDownNameChanged={(e) => setDropDownActivityItemName(e.target.value)}
                dropDownItems={activityDropDownObj?.dropDownItems}
                onSaveDropDownItemClick={onSaveActivityItemClickHandler}
                onDeleteDropDownItemClick={onDeleteActivityItemClickHandler}
                onSelectDropDownItem={onSelectActivity}
            >
                <MultipleSelection
                    title={t('Select subject')}
                    optionList={subjectOptionList}
                    onToggle={toggleOption}
                    selectedOptions={activitySubjectsSelectedOpt}
                />
            </EditDropDown>


        </artical>
    )
}